import OpportunityListItem from "./OpportunityListItem";
import withSlideUpAnimation from "./withSlideUpAnimation";

const AnimatedOpportunityListItem = withSlideUpAnimation(OpportunityListItem);

export default AnimatedOpportunityListItem;
